module.exports = __webpack_public_path__ + "322151afe6ce40fd9fc91607696cdc4a.ttf";